export interface ScreenRecordingProps {
  /** The source file for the screen recording. */
  src: string;

  /**
   * The accessibility label for the screen recording element. Used by
   * VoiceOver on iOS.
   */
  ariaLabel: string;

  /** Additional style to apply to the screen recording video element. */
  style?: React.CSSProperties;
}

/**
 * A video element that plays a screen recording. Video is muted and autoplayed.
 * Plays inline and loops.
 */
export function ScreenRecording({
  src,
  ariaLabel,
  style,
}: ScreenRecordingProps) {
  return (
    <video
      src={src}
      aria-label={ariaLabel}
      role="img"
      autoPlay
      loop
      muted
      playsInline
      style={{ width: 175, ...style }}
    />
  );
}
